export default __webpack_public_path__ + "b8e951248f43f97a4dd4e30c31e56296.svg";